import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Button, TextField } from 'mw-style-react';
import cn from 'classnames';
import './FAQ.scss';
import Link from '../../i18n/Link';
import Form from '../../components/Form/Form';
import Utils from '../../utils/utils';

const host = process.env.GATSBY_HOST;

const form = {
  title: 'formLiveDemoContactUs',
  type: 'liveDemo',
  fields: [
    {
      type: 'firstName',
      label: 'formFirstName',
      value: '',
    },
    {
      type: 'lastName',
      label: 'formLastName',
      value: '',
    },
    {
      type: 'email',
      label: 'formEmail',
      value: '',
    },
    {
      type: 'company',
      label: 'formCompany',
      value: '',
    },
    {
      type: 'chanel',
      label: 'formChanel',
      value: '',
      list: [
        {
          value: 'Zoom',
        },
        {
          value: 'Skype',
        },
        {
          value: 'formChanelOther',
        },
      ],
    },
    {
      type: 'date',
      label: 'formDate',
      value: '',
    },
    {
      type: 'message',
      label: 'formMessage',
      value: '',
    },
  ],
  button: {
    text: 'formSend',
    link: `${host}/api/1/json/public/513644/6d85995d468d2cd7d26930393473dff049842412`,
  },
};

class FAQPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      type: 'general',
      oldType: 'general',
      findText: '',
      showQuestions: true,
    };
  }

  // _handleScroll() {
  //   this.addHypercomments();
  // }
  //
  // addHypercomments() {
  //   if (typeof window !== 'undefined') {
  //     const script = `_hcwp = window._hcwp || [];
  //       _hcwp.push({widget:"Stream", widget_id: 106047});
  //       (function() {
  //       if("HC_LOAD_INIT" in window)return;
  //       HC_LOAD_INIT = true;
  //       var lang = (navigator.language || navigator.systemLanguage ||
  //          navigator.userLanguage ||  "en").substr(0, 2).toLowerCase();
  //       var hcc = document.createElement("script");
  //          hcc.type = "text/javascript"; hcc.async = true;
  //       hcc.src = ("https:" == document.location.protocol ? "https" : "http")+"://w.hypercomments.com/widget/hc/106047/"+lang+"/widget.js";
  //       var s = document.getElementsByTagName("script")[0];
  //       s.parentNode.insertBefore(hcc, s.nextSibling);
  //       })();`;
  //     // Utils.addTag('script', {
  //     //   innerText: script
  //     // });
  //     setTimeout(() => {
  //       const s = document.createElement('script');
  //       s.type = 'text/javascript';
  //       s.innerText = script;
  //       console.log('s', s);
  //       document.getElementsByTagName('body')[0].appendChild(s);
  //     }, 100);
  //   }
  // }

  renderItem(items) {
    const { type, findText, oldType } = this.state;
    const renderType = type === oldType ? type : oldType;
    let renderItems = items[renderType];
    if (findText) {
      renderItems = items[renderType].filter((item) => {
        const question = item.question.toLowerCase();
        const answer = item.answer.toLowerCase();
        const ft = findText.toLowerCase();
        return question.indexOf(ft) !== -1 || answer.indexOf(ft) !== -1;
      });
    }

    if (renderItems.length > 0) {
      return renderItems.map((item, index) => (
        <div className="faq__item" key={index}>
          <div className="faq__item__title">{item.question}</div>
          <span
            className="faq__item__text"
            dangerouslySetInnerHTML={{
              __html: Utils.bbCodeToHtml(item.answer),
            }}
          />
        </div>
      ));
    }
    return (
      <div className="faq__form">
        <Form data={form} />
      </div>
    );
  }

  handleChange(findText) {
    const self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.setState({
        showQuestions: false,
      });
      setTimeout(() => {
        self.setState({
          findText,
          showQuestions: true,
        });
      }, 500);
    }, 500);
  }

  handleChangeType(type) {
    const { findText } = this.state;
    const self = this;
    this.timeout = setTimeout(() => {
      this.setState({
        showQuestions: false,
        type,
      });
      setTimeout(() => {
        self.setState({
          findText,
          showQuestions: true,
          oldType: type,
        });
      }, 500);
    });
  }

  render() {
    const { data, intl } = this.props;
    const { questions, title, findText, generalText, technicalText } = data;
    const locale = intl.locale;
    const { type, showQuestions } = this.state;
    const filterItems = questions[locale];

    return (
      <section className="faq">
        <div className="faq__header">
          <div className="faq__wrapper">
            <div className="faq__header__title">
              <h1>{intl.formatMessage({ id: title })}</h1>
            </div>
            <TextField
              id={'find'}
              leftIcon={'Search'}
              className="faq__header__input"
              placeholder={intl.formatMessage({ id: findText })}
              onChange={(data) => this.handleChange(data.value)}
            />
          </div>
        </div>
        <div className="faq__wrapper">
          <div className="faq__content">
            <div className="faq__content__buttons">
              <Button
                className={cn('faq__content__btn', {
                  button__default: type === 'general',
                  button__secondary: type !== 'general',
                })}
                label={intl.formatMessage({ id: generalText })}
                onClick={() => this.handleChangeType('general')}
              />
              <Button
                className={cn('faq__content__btn', {
                  button__default: type === 'technical',
                  button__secondary: type !== 'technical',
                })}
                label={intl.formatMessage({ id: technicalText })}
                onClick={() => this.handleChangeType('technical')}
              />
            </div>
            <div
              className={cn({
                hidden: !showQuestions,
                show: showQuestions,
              })}
            >
              {this.renderItem(filterItems)}
            </div>
          </div>
        </div>
        <div id="hypercomments_widget" className="faq__demo__hyper" />
        <div className="faq__demo">
          <div className="faq__demo__wrapper">
            <div className="faq__demo__title">
              Project Management Body of Knowledge (PMBOK)
            </div>
            <div className="faq__item">
              <div className="faq__item__title">
                How do Corezoid and Simulator.Company comply with the PMBOK 7th
                Edition standards, and how is compliance ensured?
              </div>
              <div className="faq__item__text">
                <p>
                  Corezoid and Simulator.Company technology stack fully comply
                  with all 12 principles of PMBOK 7th Edition:
                </p>
                <ol>
                  <li>Be a diligent, respectful, and caring steward</li>
                  <li>Create a collaborative project team environment</li>
                  <li>Effectively engage stakeholders</li>
                  <li>Focus on value</li>
                  <li>
                    Recognize, evaluate, and respond to system interactions
                  </li>
                  <li>Demonstrate leadership behaviors</li>
                  <li>Tailor based on context</li>
                  <li>Build quality into processes and deliverables</li>
                  <li>Navigate complexity</li>
                  <li>Optimize risk responses</li>
                  <li>Embrace adaptability and resiliency</li>
                  <li>Enable change to achieve the envisioned future state</li>
                </ol>
                <p>
                  Besides full alignment with PMI Agile and PMI Traditional
                  methodologies, which effectively ensures continuous compliance
                  with PMBOK 7th Edition, Corezoid and Simulator.Company provide
                  the following native capabilities:
                </p>
                <ol>
                  <li>Full Project Lifecycle Support</li>
                  <li>Real-time Monitoring and Change Management</li>
                  <li>
                    Effective Stakeholder Engagement and Communication by
                    integrating multiple communication channels, enabling
                    automated, timely, and transparent communication processes.
                  </li>
                  <li>Documentation and Knowledge Management</li>
                </ol>
              </div>
            </div>

            <div className="faq__item">
              <div className="faq__item__title">
                How do Corezoid and Simulator.Company support the full project
                lifecycle (from initiation to completion) according to PMBOK
                standards?
              </div>
              <div className="faq__item__text">
                Corezoid and Simulator.Company fully support all project
                lifecycle stages (modeling, initiation, planning, execution,
                monitoring and controlling, operational support), offering
                flexible process adaptation tailored to specific project needs.
                The integrated low-code environment aligns with PMBOK 7th
                Edition principles providing high flexibility. This
                significantly reduces risks and improves planning accuracy,
                resulting in a 60–80% reduction in time required to launch new
                products and projects.
              </div>
            </div>

            <div className="faq__item">
              <div className="faq__item__title">
                How do these platforms ensure process control, monitoring, and
                change management throughout the project?
              </div>
              <div className="faq__item__text">
                Corezoid and Simulator.Company provides real-time dashboards for
                process monitoring and performance tracking, allowing continuous
                oversight of task completion and key performance indicators, as
                well as automated reactions to deviations. The integrated
                low-code environment allows continuous change management,
                testing at each stage.
              </div>
            </div>
            <div className="faq__item">
              <div className="faq__item__title">
                How do Corezoid and Simulator.Company enhance communication and
                stakeholder engagement in my projects?
              </div>
              <div className="faq__item__text">
                Corezoid and Simulator.Company integrates various communication
                channels (chatbots, email, messengers, etc) and automates
                notifications to stakeholders, ensuring rapid and transparent
                communication. This approach fully aligns with PMBOK standards
                for active stakeholder engagement and maintaining transparency.
                Communication effectiveness improves by 30–50%, and
                responsiveness increases by 2–3 times.
              </div>
            </div>
            <div className="faq__item">
              <div className="faq__item__title">
                How is documentation and knowledge management supported by
                Corezoid and Simulator.Company?
              </div>
              <div className="faq__item__text">
                Corezoid and Simulator.Company enables the process of automatic
                documentation of each step and change within processes, creating
                a transparent and comprehensive action history. Any change in
                the state of the process triggers transactions and recursively
                transactions trigger changes in states of the process
                automatically being reflected in the documentation. This
                practice aligns with PMBOK principles of structured
                documentation management. As a result, project managers gain
                quick access to information, simplifying documentation
                maintenance and ensuring up-to-date records. The time spent on
                documentation management decreases by 40–60%.
              </div>
            </div>
          </div>
        </div>
        {/* {this.addHypercomments()}*/}
        <div className="faq__demo">
          <div className="faq__demo__wrapper">
            <div className="faq__demo__title">
              {intl.formatMessage({ id: 'faqDemoTitle' })}
            </div>
            <div className="faq__demo__buttons">
              <Link to={intl.formatMessage({ id: 'faqDemoBtnCreateLink' })}>
                <Button
                  className="button__default faq__demo__btn"
                  label={intl.formatMessage({ id: 'faqDemoBtnCreate' })}
                />
              </Link>
              <Link to={'/form/live-demo'}>
                <Button
                  className="button__secondary faq__demo__btn"
                  label={intl.formatMessage({ id: 'faqDemoBtnDemo' })}
                />
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

FAQPage.propTypes = {
  data: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(FAQPage);
